// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87483c53","453":"56359695"}[chunkId] + ".chunk.js";
};